import React, { useEffect } from 'react';
import Layout from '../../hoc/Layout';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Quiz from '../../containers/Quiz';
import QuizList from '../../containers/QuizList';
import Auth from '../../containers/Auth';
import QuizCreator from '../../containers/QuizCreator';
import { connect } from 'react-redux'
import Logout from '../Logout';
import { autoLogin } from '../../store/actions/auth';
import { bool, func } from 'prop-types';

const App = ({ isAuthenticated, autoLogin }) => {
  useEffect(() => {
    autoLogin()
  }, [autoLogin])

  let routes = (
    <Switch>
      <Route path="/auth" component={Auth} />
      <Route path="/quiz/:id" component={Quiz} />
      <Route path="/" exact component={QuizList} />
      <Redirect to={'/'} />
    </Switch>
  )

  if (isAuthenticated) {
    routes = (
      <Switch>
        <Route path="/quiz-creator" component={QuizCreator} />
        <Route path="/quiz/:id" component={Quiz} />
        <Route path="/logout" component={Logout} />
        <Route path="/" exact component={QuizList} />
        <Redirect to={'/'} />
      </Switch>
    )
  }

  return (
    <Layout>
      {routes}
    </Layout>
  )
}

const mapStateToProps = ({ auth: { token } }) => ({ isAuthenticated: !!token })

App.propTypes = {
  isAuthenticated: bool,
  autoLogin: func,
}

App.defaultProps = {
  isAuthenticated: false,
  autoLogin: () => { },
}

export default withRouter(connect(mapStateToProps, { autoLogin })(App))
